import { useEffect, useState } from 'react';

function useTimer(seconds: number, options?: { onFinish?: Function }) {
  const [timer, setTimer] = useState(seconds);

  const resetTimer = () => setTimer(seconds);

  useEffect(() => {
    let interval: NodeJS.Timer = null;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((seconds) => seconds - 1);
      }, 1000);
    } else {
      options?.onFinish?.();
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);

  return { timer, resetTimer };
}

export default useTimer;
